var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block w-100"},[_c('listado-acuerdos-lineas-tabla',{attrs:{"getListaAcuerdosLineas":_vm.getListaAcuerdosLineas,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }